var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-box"},[_c('el-carousel',{attrs:{"height":"316px"}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index},[_c('el-image',{staticClass:"banner-image",attrs:{"src":item.img_show,"mode":"scaleToFill"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }